import firebase from 'firebase';


  const firebaseConfig = {
    apiKey: "AIzaSyBFHG5Ph8idYQbVKROPDNTDoQTJbWT6QaM",
    authDomain: "sona-machinery-admin.firebaseapp.com",
    projectId: "sona-machinery-admin",
    storageBucket: "sona-machinery-admin.appspot.com",
    messagingSenderId: "775658454626",
    appId: "1:775658454626:web:b251bd8382449c9d695b3b"
  };


firebase.initializeApp(firebaseConfig);
var storage = firebase.storage();

export default storage;